export const LOGO = require('./logo.png'); 
export const ARROW = require('./arrow.png'); 
export const DOWNLOAD = require('./download.png'); 
export const DOWNLOAD2 = require('./download_2.png'); 
export const FRAME = require('./frame.png'); 
export const BOX1=require('./box_1.png');
export const BOX2=require('./box_2.png');
export const TICK=require("./tick.png");
